import { Button, Input, Modal } from "@deligoo/ui"
import { unwrapResult } from "@reduxjs/toolkit"
import { FormEvent, useState } from "react"
import { toast } from "react-toastify"
import { Rifm } from "rifm"

import { useAppDispatch, useAppSelector } from "@/App"
import { selectClientById, updateTemporaryDistanceLimit } from "@/store/clients"
import { Client } from "@/types"
import { integerAccept, parseNumber } from "@/utils"

import cls from "../ClientContextMenu.module.scss"

type DistanceLimitModalProps = {
  clientId: Client["id"]
  handleClose: () => void
}

export const DistanceLimitModal = ({ clientId, handleClose }: DistanceLimitModalProps) => {
  const client = useAppSelector(selectClientById(clientId))

  const [distanceLimitTime, setDistanceLimitTime] = useState("5 (min)")
  const [temporaryDistanceLimit, setTemporaryDistanceLimit] = useState("")

  const dispatch = useAppDispatch()

  if (!client) return null

  function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault()

    dispatch(
      updateTemporaryDistanceLimit({
        clientId: client!.id,
        body: {
          distance_limit_time: parseInt(distanceLimitTime),
          temporary_distance_limit: Number(temporaryDistanceLimit),
        },
      })
    )
      .then(unwrapResult)
      .then((res) => {
        if (res.ok) {
          toast.success("Pomyślnie ustawiono tymczasowy limit odległości")
          handleClose()
        } else {
          toast.error("Nie udało się ustawić tymczasowego limitu odległości")
        }
      })
  }

  return (
    <Modal handleClose={handleClose} className={cls.distanceLimitModal} closeBtnPosition="inside">
      <Modal.Title>
        Limit odległości
        <div className="h200 text-primary mt-1">
          {client.name} - {client.deligoo_max_distance_limit} km
        </div>
      </Modal.Title>

      <Modal.Content>
        <form onSubmit={handleSubmit}>
          <Rifm
            accept={integerAccept}
            value={distanceLimitTime}
            onChange={setDistanceLimitTime}
            format={(val) => `${parseNumber(val)} (min)`}
          >
            {({ value, onChange }) => (
              <Input placeholder="Czas (min)" value={value} type="text" min={0} plain required onChange={onChange} />
            )}
          </Rifm>

          <Input
            placeholder="Tymczasowy dystans (km)"
            value={temporaryDistanceLimit}
            onChange={(e) => setTemporaryDistanceLimit(e.currentTarget.value)}
            className="mt-5"
            type="number"
            min={0}
            max={100}
            plain
            required
            autoFocus
          />

          <div className={cls.actions}>
            <Button onClick={handleClose} color="muted" variation="outlined">
              Anuluj
            </Button>

            <Button color="primary" type="submit" raised>
              Zmień limit
            </Button>
          </div>
        </form>
      </Modal.Content>
    </Modal>
  )
}
